import { ProfileActionsContentWithConnection } from "./ProfileActionsContentWithConnection/ProfileActionsContentWithConnection";

interface ProfileActionsContentProps {
  closeDisplay: () => void;
}

export const ProfileActionsContent = ({ closeDisplay }: ProfileActionsContentProps) => {
  return <ProfileActionsContentWithConnection closeDisplay={closeDisplay} />;
};
